import { convertObjToFormData } from "helper/data-converter";
import client from "./config";

//////////////// education year ////////////////

const educationYearUrl = "/educational_year";
export const getEducationYearRequest = (values) => {
  return client.get(educationYearUrl, values);
};

//////////////// login ////////////////
export const loginStudentRequest = (values) =>
  client.post("student/login", values);

export const loginTeacherRequest = (values) => {
  return client.post("/teacher/login", values);
};

//////////////// reset pssword ////////////////
export const getOtpRequest = (values) =>
  client.post("/student/send_otp", values);

export const resetPasswordRequest = (values) =>
  client.post("/student/reset_password", values);

//////////////// user info ////////////
const userInfoUrl = "/user_info";
export const getUserInfoRequest = (values) => client.get(userInfoUrl);

//////////////// conversation ////////////
const conversationUrl = "/student/teacher_student_conversation";

export const addMessageToConversationRequest = (values, onUploadProgress) => {
  !values.file && delete values.file;
  const formData = convertObjToFormData(values);
  return client.post(conversationUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const getConversationsRequest = (values) =>
  client.get(conversationUrl, values);

export const getConversationsMessagesRequest = (values) =>
  client.get(`${conversationUrl}/${values}`);

//////////////// conversation ////////////
const messageUrl = "/student/teacher_student_message";

export const deleteMessagesRequest = (values) =>
  client.delete(`${messageUrl}/${values}`);

//////////////// student calss ////////////
const studentClassUrl = "/student/class";

export const getStudentClassesRequest = (values) =>
  client.get(studentClassUrl, values);

//////////////// student score ////////////
const studentScoreUrl = "/student/score";

export const getStudentScoresRequest = (values) =>
  client.get(studentScoreUrl, values);

//////////////// student messages ////////////
const studentMessageUrl = "/student/message";

export const getStudentMessagesRequest = (values) =>
  client.get(studentMessageUrl, values);

export const getStudentMessagesByIdRequest = (values) =>
  client.get(`${studentMessageUrl}/${values}`, values);

//////////////// student financial ////////////
const studentFinancialUrl = "/student/financial";

export const getStudentFinancialRequest = (values) => {
  !values.from_date && delete values.from_date;
  !values.to_date && delete values.to_date;
  if (values.payment_status === "0" && !values.payment_status) {
    values.payment_status = false;
  }
  values?.search?.trim() === "" && delete values.search;
  return client.get(studentFinancialUrl, values);
};

//////////////// student attendance ////////////
const studentAttendanceUrl = "/student/attendance";

export const getStudentAttendanceUrlRequest = (values) => {
  !values.from_date && delete values.from_date;
  !values.to_date && delete values.to_date;
  return client.get(studentAttendanceUrl, values);
};

//////////////// student class file ////////////
const studentClassFileUrl = "/student/class_file";

export const getStudentClassFileRequest = (values) => {
  return client.get(studentClassFileUrl, values);
};

//////////////// student teacher ////////////
const studentTeacherUrl = "/student/teacher";

export const getStudentTeacherRequest = (values) =>
  client.get(studentTeacherUrl, values);

//////////////// Student Financial Stats ////////////
const studentFinancialStatsUrl = "/student/financial_stat";

export const getStudentFinancialStatsRequest = (values) =>
  client.get(studentFinancialStatsUrl, values);

// => teacher <= /////////////////////////////////////////////////////////////////

//////////////// teacher financial ////////////
const teacherFinancialUrl = "/teacher/financial";

export const getTeacherFinancialRequest = (values) => {
  !values.from_date && delete values.from_date;
  !values.to_date && delete values.to_date;
  values?.search?.trim() === "" && delete values.search;
  return client.get(teacherFinancialUrl, values);
};

//////////////// teacher calss ////////////
const teacherClassUrl = "/teacher/class";

export const getTeacherClassesRequest = (values) =>
  client.get(teacherClassUrl, values);

//////////////// teacher calss_file ////////////
const teacherClassFileUrl = "/teacher/class_file";

export const getTeacherClassFileRequest = (values) =>
  client.get(teacherClassFileUrl, values);

export const getTeacherClassFileByIdRequest = (values) =>
  client.get(`${teacherClassFileUrl}/${values}`, values);

export const deleteTeacherClassFileByIdRequest = (values) =>
  client.delete(`${teacherClassFileUrl}/${values}`, values);

export const addTeacherClassFileRequest = (values, onUploadProgress) => {
  const formData = convertObjToFormData(values);
  return client.post(teacherClassFileUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const editTeacherClassFileRequest = (values, onUploadProgress) => {
  const formData = convertObjToFormData(values);
  return client.post(
    `${teacherClassFileUrl}/${values.id}?_method=put`,
    formData,
    {
      onUploadProgress: (progress) =>
        onUploadProgress((progress.loaded / progress.total) * 100),
    }
  );
};

////////////////  attendance ////////////////
const attendaceUrl = "/teacher/attendance";

// add new attendance
export const addAttendaceRequest = (values) =>
  client.post(attendaceUrl, values);

// get attendance data
export const getAttendaceRequest = (values) => {
  !values.from_date && delete values.from_date;
  !values.to_date && delete values.to_date;
  return client.get(attendaceUrl, values);
};

// get attendance by id
export const getAttendaceByIdRequest = (values) =>
  client.get(`${attendaceUrl}/${values.attendance_id}`, values);

// update attendance by id
export const updateAttendaceByIdRequest = (values) => {
  return client.post(
    `${attendaceUrl}/${values.attendance_id}?_method=put`,
    values
  );
};

//////////////// students list ////////////////
const studentsListUrl = "/teacher/student";

export const getStudentsListRequest = (values) =>
  client.get(studentsListUrl, values);

///////// scores //////
const scoreUrl = "/teacher/score";

// add score
export const addTeacherClassScoreRequest = (values) =>
  client.post(scoreUrl, values);

// delete score by id
export const deleteClassScoreByIdRequest = (values) =>
  client.delete(`${scoreUrl}/${values}`);

// get class scores
export const getTeacherClassScoresRequest = (values) => {
  !values.from_date && delete values.from_date;
  !values.to_date && delete values.to_date;
  return client.get(scoreUrl, values);
};
// get class scores by id
export const getTeacherClassScoreByIdRequest = (values) =>
  client.get(`${scoreUrl}/${values}`);
// update class score by id
export const updateTeacherClassScoreByIdRequest = (values) => {
  !values.date && delete values.date;
  return client.post(`${scoreUrl}/${values.id}?_method=put`, values);
};

//////////////// teacher ////////////
const teacherConversationUrl = "/teacher/teacher_student_conversation";

export const addTeacherMessageToConversationRequest = (
  values,
  onUploadProgress
) => {
  !values.file && delete values.file;
  const formData = convertObjToFormData(values);
  return client.post(teacherConversationUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const getTeacherConversationsRequest = (values) =>
  client.get(teacherConversationUrl, values);

export const getTeacherConversationsMessagesRequest = (values) =>
  client.get(`${teacherConversationUrl}/${values}`);

export const deleteTeacherConversationsMessageRequest = (values) =>
  client.delete(`${teacherConversationUrl}/${values}`);

//////////////// student teacher ////////////
export const getTeacherStudentRequest = (values) =>
  client.get("/teacher/student", values);

//////////////// send message ////////////
export const sendMessageRequest = (values) =>
  client.post("/teacher/message", values);

//////////////// Teacher Financial Stats ////////////
const teacherFinancialStatsUrl = "/teacher/financial_stat";

export const getTeacherFinancialStatsRequest = (values) =>
  client.get(teacherFinancialStatsUrl, values);

//////////////// reset pssword ////////////////
export const getTeacherOtpRequest = (values) =>
  client.post("/teacher/send_code", values);

export const resetTeacherPasswordRequest = (values) =>
  client.post("/teacher/check_otp", values);

//////////////// teacher recived messages ////////////////
const teacherRecivedMessagesUrl = "/teacher/message_to_teacher";
export const getTeacherMessagesRequest = (values) =>
  client.get(teacherRecivedMessagesUrl, values);

export const getTeacherMessageByIdRequest = (id) =>
  client.get(`${teacherRecivedMessagesUrl}/${id}`);

//////////////// student excellscore view //////////////
const studentScoresExcellFileUrl = "/student/excel_score";
const studentScoresExcellUrl = "/student/excel_student_score";
export const getStudentScoresExcellFileRequest = (values) =>
  client.get(studentScoresExcellFileUrl, values);

export const getStudentScoresExcellFileByIdRequest = (values) =>
  client.get(`${studentScoresExcellFileUrl}/${values.id}`);

export const getStudentScoresExcellByIdRequest = (values) =>
  client.get(`${studentScoresExcellUrl}${"?score_id=" + values.id}`);

//////////////// teacher excellscore view //////////////
const teacherScoresExcellFileUrl = "/teacher/excel_score";
export const getTeacherScoresExcellFileRequest = (values) =>
  client.get(teacherScoresExcellFileUrl, values);
export const getTeacherScoresExcellFileByIdRequest = (values) =>
  client.get(`${teacherScoresExcellFileUrl}/${values.id}`);

export const addScoresExcellFileRequest = (values, onUploadProgress) => {
  const formData = convertObjToFormData(values);

  return client.post(teacherScoresExcellFileUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// student score test ////////////
const studentScoreExamUrl = "/student/exam";

export const getStudentScoresExamRequest = (values) =>
  client.get(studentScoreExamUrl, values);

//////////////////////  test score ///////////////////
const testScoreUrl = "/teacher/exam";
export const getScoresTestRequest = (values) =>
  client.get(testScoreUrl, values);
export const getScoresExamAnswersByIdRequest = (values) =>
  client.get(`${testScoreUrl}/${values.id}`);

////////////////   comprehensive exam آزمون جامع ////////////////////
const getAllissuereportcardComUrl = "/student/c_exam_answers";
export const getAllReportCardUserCom = (values) =>
  client.get(getAllissuereportcardComUrl, values);

////////////////   //comprehensive exam آزمون جامع ////////////////////
